import styled from 'styled-components';

import ArrowDownIcon from '@web/assets/svg/UI/dropdown-gray.svg';

export const PreviousTaskButton = styled(ArrowDownIcon)`
  cursor: pointer;
  rotate: 90deg;
`;

export const NextTaskButton = styled(ArrowDownIcon)`
  cursor: pointer;
  rotate: -90deg;
`;

export const Spacer = styled.div`
  width: 34px;
  height: 34px;
`;
